/* eslint-disable jsx-a11y/anchor-is-valid */
import { PersonalSubContratado } from '../../../../../types/PersonalSubContratado';
import Table, {
  ColumnDefinitionType,
} from '../../../../../components/Table';
import { usePersonalAfectado } from '../../../../../hooks/usePersonalAfectado';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MyModal from '../../../../../components/Modal';
import DetailPersonalSubContratado from '../DetailPersonalSubContratado';
import { useDocumentoPersAfectado } from '../../../../../hooks/useDocumentoPersAfectado';
import EditPersonalSubContratado from '../DetailPersonalSubContratado/EditPersonalSubContratado';
import { useSolicitud } from '../../../../../hooks/useSolicitud';
import { uploadFiles } from '../../../../../services/Service';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { useSolicitudPermissions } from '../../../../../hooks/useSolicitudPermissions';
import { logger } from '../../../../../utils/logger';

interface TablePersonalSubContratadoProps {
  tiposDocumentosPers: any;
  onClose: () => void;
  onModalAction: (isOpen: boolean) => void;
  isEditing: boolean;
  modalOpen: boolean;
  onIsEditing: (updateEditable: boolean) => void;
}

const TablePersonalSubContratado: React.FC<
  TablePersonalSubContratadoProps
> = ({
  onClose,
  isEditing,
  onIsEditing,
  tiposDocumentosPers,
  modalOpen,
  onModalAction,
}) => {
  const {
    personalSubContratadoList,
    handlePersonalSubContratadoSelected,
    eliminarPersonalSubContratadoById,
    personalSubContratadoSelected,
    saveOrUpdatePersonalAfectado,
  } = usePersonalAfectado();
  const {
    buscarDocPersSubContratadoByIdSubContratado,
    setEmptyListAllDocumentoPersonalAfectado,
    documentoPersonalSubContratadoList,
    deleteDocPersById,
  } = useDocumentoPersAfectado();
  const { cargarCombo, solicitudSelected, buscarSolicitud } =
    useSolicitud();

  // Usar el hook unificado de permisos
  const { shouldShowDocumentStatusColumn, canDelete } =
    useSolicitudPermissions({
      solicitudEstadoId: solicitudSelected.idTipoEstado,
    });

  const [
    isConfirmDeletePersonalSubCon,
    setIsConfirmDeletePersonalSubCon,
  ] = useState(false);
  const [personIdSelect, setPersonIdSelect] = useState<number>();
  const [actividades, setActividades] = useState<any>([]);
  const [isVisualizar, setIsVisualizar] = useState(false);
  const [limiteExcedido, setLimiteExcedido] = useState(false);

  useEffect(() => {
    cargarCombo(
      `actividad/activasPorContratista/${solicitudSelected.id}`,
      setActividades
    );
  }, [cargarCombo, solicitudSelected.id]);

  const columns: ColumnDefinitionType<
    PersonalSubContratado,
    keyof PersonalSubContratado
  >[] = [];
  columns.push({
    key: 'apellido',
    header: 'Apellido',
  });
  columns.push({
    key: 'nombre',
    header: 'Nombre',
  });
  columns.push({
    key: 'tipoDocumento',
    header: 'Tipo Doc Persona',
  });
  columns.push({
    key: 'nroDocumento',
    header: 'Nro Documento',
  });
  columns.push({
    key: 'empresa',
    header: 'Empresa',
  });
  columns.push({
    key: 'fechaIngreso',
    header: 'Fecha Ingreso',
    cell: (data: PersonalSubContratado) => (
      <>
        {data.fechaIngreso
          ? moment(data.fechaIngreso).format('DD/MM/YYYY')
          : ''}
      </>
    ),
  });
  columns.push({
    key: 'actividad',
    header: 'Actividad',
  });
  columns.push({
    key: 'id',
    header: 'Acciones',
    cell: (data: PersonalSubContratado) => (
      <>
        <Link
          title="Visualizar"
          to="/exportar"
          onClick={(e) => {
            buscarDocPersSubContratadoByIdSubContratado(data.id);
            handlePersonalSubContratadoSelected(data);
            setIsVisualizar(true);
            onModalAction(true);
            e.preventDefault();
          }}
          target="_blank"
        >
          <i
            className="fa fa-eye text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        {isEditing && (
          <Link
            title="Editar"
            to=""
            onClick={(e) => {
              buscarDocPersSubContratadoByIdSubContratado(data.id);
              handlePersonalSubContratadoSelected(data);
              onIsEditing(true);
              onModalAction(true);
              e.preventDefault();
            }}
            target="_blank"
          >
            <i
              className="fa fa-pencil text-secondary me-2"
              aria-hidden="true"
            ></i>
          </Link>
        )}
        {isEditing && canDelete && (
          <Link
            title="Eliminar"
            to=""
            onClick={(e) => {
              setPersonIdSelect(data.id);
              setIsConfirmDeletePersonalSubCon(true);
              e.preventDefault();
            }}
            target="_blank"
          >
            <i
              className="fa fa-trash text-secondary me-2"
              aria-hidden="true"
            ></i>
          </Link>
        )}
      </>
    ),
  });

  // Usar el hook para mostrar columna de status documento
  if (shouldShowDocumentStatusColumn) {
    columns.push({
      key: 'statusDocumento',
      header: '',
    });
  }

  const handleConfirmDeletePerson = () => {
    eliminarPersonalSubContratadoById(`${personIdSelect}`).finally(
      () => setIsConfirmDeletePersonalSubCon(false)
    );
  };

  const handlePersonalSubContratadoSave = (
    data: any,
    currentSave: HTMLButtonElement | null
  ) => {
    debugger;
    let dataForm = {
      actividad: data.actividad,
      apellido: data.apellido,
      fechaIngreso: data.fechaIngreso,
      nombre: data.nombre,
      idTipoDocumento: data.tipoDocumento,
      tipoDocumento: data.tipoDocumento,
      observaciones: data.observaciones,
      nroDocumento: data.nroDocumento,
      vigente: data.vigente,
      idActividad: data.actividad,
      idSolicitud: solicitudSelected.id,
      empresa: data.empresa,
      id: data.id,
      statusDocumento: '',
      idRolPlanEmergencia: data.idRolPlanEmergencia,
      intervienePlanEmergencia: data.intervienePlanEmergencia,
    };

    saveOrUpdatePersonalAfectado('personal-subcontratado', dataForm)
      .then((result) => {
        // Maneja el resultado si es necesario
        logger.log('Operación completada');

        if (result) {
          buscarSolicitud(dataForm.idSolicitud.toString());
          findDeletedDocuments(
            data.documentosPersSubContratado
          ).forEach((documentDelete) =>
            deleteDocPersById(
              'documento-personal-subcontratado',
              documentDelete.id
            )
          );
          let documentUpload =
            data.documentosPersSubContratado.filter(
              (documentPersPropio: any) =>
                documentPersPropio.archivoSeleccionado
            );
          if (!documentUpload || documentUpload.length < 1) {
            onClose();
            return;
          }

          let idPersonalPropio = result.data.id;
          let fileDataArray = documentUpload.map(
            (documentPersPropio: any) => {
              const uniqueId: string = uuidv4();

              return {
                file: documentPersPropio.archivoSeleccionado,
                parameters: {
                  idTipoDocumento: documentPersPropio.idTipoDocumento,
                  idDocumento: documentPersPropio.id,
                  fileId: uniqueId,
                  sizeMaximo: documentPersPropio.sizeMaximo,
                  ...(documentPersPropio.fechaVencimiento
                    ? { fechaVencimiento: documentPersPropio.fechaVencimiento }
                    : {}),
                },
              };
            }
          );
          uploadFiles(
            `documento-personal-subcontratado/subirArchivoPersonal/${idPersonalPropio}`,
            fileDataArray
          )
            .then((result) => {
              if (result) {
                setLimiteExcedido(false);
                onClose();
              }
              currentSave!.disabled = false;
            })
            .catch((error) => {
              if (error.response.status === 413) {
                currentSave!.disabled = false;
                setLimiteExcedido(true);
                toast.error(error.response.data.message);
              } else {
                toast.error(
                  'No se pudo adjuntar el archivo seleccionado'
                );
              }
            });
        }

        //uploadFiles(`${result}`, [])
      })
      .catch((error) => {
        // Maneja los errores si ocurren
        logger.error('Error:', logger.safeError(error));
      });
  };

  const findDeletedDocuments = (newList: any[]): any[] => {
    const deletedDocuments: any[] = [];

    for (const existingDocument of documentoPersonalSubContratadoList) {
      const existsInNewList = newList.some(
        (newDocument) =>
          newDocument.idTipoDocumento ===
            existingDocument.idTipoDocumento &&
          newDocument.id === existingDocument.id
      );

      if (!existsInNewList) {
        deletedDocuments.push(existingDocument);
      }
    }

    return deletedDocuments;
  };

  return (
    <>
      <MyModal
        isOpen={isConfirmDeletePersonalSubCon}
        toggle={() => setIsConfirmDeletePersonalSubCon(false)}
        title="Advertencia"
        cancelButton={true}
        secondButton={true}
        secondButtonTitle={'Aceptar'}
        secondButtonFn={handleConfirmDeletePerson}
      >
        <label>Desea confirmar eliminar el Personal?</label>
      </MyModal>
      <MyModal
        size="lg"
        isOpen={modalOpen}
        toggle={() => {
          onClose();
          setEmptyListAllDocumentoPersonalAfectado();
          setIsVisualizar(false);
        }}
        cancelButton={false}
        secondButton={false}
        title={
          (isVisualizar
            ? 'Vista'
            : personalSubContratadoSelected.id === 0
            ? 'Agregar'
            : 'Editar') + ' Personal SubContratado'
        }
      >
        {isVisualizar ? (
          <DetailPersonalSubContratado
            onClose={() => {
              onModalAction(false);
              setEmptyListAllDocumentoPersonalAfectado();
              setIsVisualizar(false);
            }}
          />
        ) : (
          <EditPersonalSubContratado
            tiposDocumentosPers={tiposDocumentosPers}
            limiteExcedido={limiteExcedido}
            isEditing={isEditing}
            actividades={solicitudSelected.actividades ?? []}
            onClose={() => {
              onClose();
              setEmptyListAllDocumentoPersonalAfectado();
            }}
            onSave={(data, currentSave) => {
              handlePersonalSubContratadoSave(data, currentSave);
              setEmptyListAllDocumentoPersonalAfectado();
            }}
          />
        )}
      </MyModal>
      <Table
        data={personalSubContratadoList}
        columns={columns}
      ></Table>
    </>
  );
};

export default TablePersonalSubContratado;
